export default "__VITE_ASSET__10555ea8__"